import React from "react";
import "./RadioButtonWithLabel.less";

interface RadioButtonWithLabelProps extends Omit<React.LabelHTMLAttributes<HTMLLabelElement>, "onChange"> {
    label?: string;
    checked?: boolean;
    disabled?: boolean;
    name?: string;
    value?: React.InputHTMLAttributes<HTMLInputElement>["value"];
    /** When true, renders children instead of label */
    hasRichContent?: boolean;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    children?: React.ReactNode;
}

const RadioButtonWithLabel: React.FC<RadioButtonWithLabelProps> = ({
    label,
    checked,
    disabled,
    name,
    value,
    hasRichContent,
    onChange,
    children,
}) => (
    <label className="radio-button-with-label">
        <input
            className="radio-button-with-label__input"
            type="radio"
            name={name}
            checked={checked}
            onChange={onChange ? onChange : undefined}
            disabled={disabled}
            value={value}
        />
        <span className="radio-button-with-label__svg-container">
            <svg
                className="radio-button-with-label__svg"
                width="20px"
                height="20px"
                viewBox="0 0 20 20"
                aria-hidden="true"
                focusable="false"
            >
                <circle className="radio-button-with-label__frame" cx="10" cy="10" r="9" />
                <circle className="radio-button-with-label__check-mark" cx="10" cy="10" r="5" />
            </svg>
        </span>
        <span className="radio-button-with-label__label-text">{hasRichContent ? children : label}</span>
    </label>
);

export default RadioButtonWithLabel;
